import type { NodeDefinition } from "../domain/types/index.js";

type NodeSpec = Omit<NodeDefinition, "id"> & { id?: never };

function node(id: NodeDefinition["id"], spec: NodeSpec): NodeDefinition {
  return { id, ...spec };
}

function caseNode(
  id: NodeDefinition["id"],
  next: readonly string[],
  x: number,
  y: number,
): NodeDefinition {
  return node(id, { kind: "case", caseId: id, next, x, y });
}

function restNode(
  id: NodeDefinition["id"],
  next: readonly string[],
  x: number,
  y: number,
): NodeDefinition {
  return node(id, { kind: "rest", next, x, y });
}

// 開始は1本。休日のあと、左は枚数、右は大規模の茨の道。
export const MAP_NODES_WIDE: Record<string, NodeDefinition> = {
  start: node("start", { kind: "start", next: ["w1"], x: 2, y: 0 }),
  w1: caseNode("w1", ["w2"], 2, 1),
  w2: caseNode("w2", ["rest-open"], 2, 2),
  "rest-open": restNode("rest-open", ["w3-l", "w3-r"], 2, 3),

  "w3-l": caseNode("w3-l", ["w4-l"], 1, 4),
  "w3-r": caseNode("w3-r", ["w3s-r"], 3, 4),
  "w4-l": caseNode("w4-l", ["w5-l"], 0, 5),
  "w3s-r": caseNode("w3s-r", ["w4-r"], 4, 5),
  "w5-l": caseNode("w5-l", ["rest-8-l", "w-xfer"], 1, 6),
  "w4-r": caseNode("w4-r", ["rest-r2"], 4, 6),

  "rest-8-l": restNode("rest-8-l", ["w6-l"], 1, 7),
  "rest-r2": restNode("rest-r2", ["w5-r"], 4, 7),
  "w6-l": caseNode("w6-l", ["w7-l"], 1, 8),
  "w-xfer": caseNode("w-xfer", ["w6-r"], 2, 8),
  "w5-r": caseNode("w5-r", ["w6-r", "rest-11-r"], 4, 8),
  "w7-l": caseNode("w7-l", ["w8-l"], 1, 9),
  "w6-r": caseNode("w6-r", ["rest-11-r"], 3, 9),

  "w8-l": caseNode("w8-l", ["rest-11-l"], 1, 10),
  "rest-11-l": restNode("rest-11-l", ["w-pre-l"], 1, 11),
  "rest-11-r": restNode("rest-11-r", ["w-pre-r"], 4, 11),
  "w-pre-l": caseNode("w-pre-l", ["rest-w-pre"], 1, 12),
  "w-pre-r": caseNode("w-pre-r", ["rest-w-pre"], 3, 12),
  "rest-w-pre": restNode("rest-w-pre", ["boss"], 2, 13),
  boss: node("boss", { kind: "case", caseId: "wide-boss", next: [], x: 2, y: 14 }),
};
